import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OptimizeOptionCard } from './OptimizeOptionCard';
import {
  AdditionalOptimizationDetails,
  Optimization,
} from './useCreateTourState';
import { TimeOptimizationAdditionalOptions } from './TimeOptimizationAdditionalOptions';
import { useCallback } from 'react';

export interface OptimizeProps {
  onOptimizeSelected: (option: Optimization) => void;
  optimization: Optimization;
}

export const Optimize: React.FC<OptimizeProps> = ({
  onOptimizeSelected,
  optimization,
}) => {
  const [t] = useTranslation('tours');

  const selectedOption = optimization.variant;

  const handleAdditionalOptimizationChange = useCallback(
    (value: AdditionalOptimizationDetails) => {
      onOptimizeSelected({
        ...optimization,
        additionalDetails: value,
      });
    },
    [onOptimizeSelected, optimization]
  );

  return (
    <Box
      sx={{
        overflow: 'auto',
        p: 4,
      }}
    >
      <Typography
        variant="h3"
        align="center"
        sx={{
          color: 'grey.900',
          fontWeight: 700,
          mx: 'auto',
        }}
      >
        {t('optimizeStepTitle')}
      </Typography>
      <Grid
        container
        spacing={6}
        sx={{
          mt: 6.5,
        }}
      >
        <Grid item sm={12} md={6} lg={6}>
          <OptimizeOptionCard
            variant="time"
            selected={selectedOption === 'time'}
            onSelect={() =>
              onOptimizeSelected({ ...optimization, variant: 'time' })
            }
          />
          {selectedOption === 'time' ? (
            <TimeOptimizationAdditionalOptions
              value={optimization.additionalDetails}
              onChange={handleAdditionalOptimizationChange}
            />
          ) : null}
        </Grid>
        <Grid item sm={12} md={6} lg={6}>
          <OptimizeOptionCard
            variant="costs"
            selected={selectedOption === 'costs'}
            onSelect={() =>
              onOptimizeSelected({ ...optimization, variant: 'costs' })
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};
